import type { FaireProductEntity } from "../../entity_types/product";

export const p_esult55j5a: FaireProductEntity = {
  token: "p_esult55j5a",
  type: "product",
  name: "Organic Hand Sanitizer - Lunar Mist",
  brandToken: "b_1alzanul2v",
  brandName: "Wildland Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/64497b8ae8d87470da1f3b21f7c38e7a7fa55bf959662c5465049aa001b2c207.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f3dd6e461353211d86ff19c5ee2de0086f664c50373399f664957be408915c36.jpeg",
    "https://cdn.faire.com/fastly/5fb526e865d86d3a8f259d77ba5dbb787178efbcb74c1db1aad45a8fcd34bd2e.jpeg",
    "https://cdn.faire.com/fastly/d91bdfc9de37ecfcdb07decd7fc89866e89fe72906ab282a4b8e4ba190d48fdd.jpeg",
    "https://cdn.faire.com/fastly/9ad6ba053fa3ec2c8ed9e5cd4d01860fe5ec8c879bfa2c1a2fc7c5e16e0afb92.jpeg",
  ],
  priceDollars: 11,
  description:
    "This viral-fighting, 72% Organic Alcohol formula promises to not only help protect your immune system, but also to support your nervous system with a calming, soothing blend of herbal extracts & essential oils. Featuring premium Organic Aloe Juice & Vegetable Glycerin to hydrate and help skin retain moisture, along with White Willow Bark to promote healthy skin cell turnover. Organic Oatstraw Extract calms & soothes mind and body. Essential Oils of Palo Santo, Lavender, Cedarwood. Formula not only meets, but exceeds, CDC guidelines for effectiveness - boasting 72% organic ethyl alcohol as the active ingredient. \n\nIngredients: Organic Ethyl Alcohol (190 Proof, derived from Sugar Cane) at 72% ratio, Water, Pentiol Green+ (naturally derived solubilizer), Sodium Lactate (naturally derived), Lavender Essential Oil, *Glycerin, Cedarwood Atlas Essential Oil, Palo Santo Essential Oil, *Willow Bark Extract, *Oat Straw Extract, *Aloe Vera Powder\n\nIndicates *Organic ^ Wildcrafted ~ Fair Trade",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:46.891Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
